import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import locales from '../../../content.json';
import s from './index.module.scss';

import stars from './img/stars.png';
import avatar1 from './img/avatar1.png';
import avatar2 from './img/avatar2.png';
import avatar3 from './img/avatar3.png';
import avatar4 from './img/avatar4.png';

import avatar1K9 from './img/avatar1-k9.png';
import avatar3K9 from './img/avatar3-k9.png';
import avatar4K9 from './img/avatar4-k9.png';

const AUTOPLAY_DELAY = 5000;

export const ReviewsSlider = React.memo(function ReviewsSlider() {
  const k9Funnel = useSelector(state => state.data.k9Funnel);
  const viewportRef = useRef(null);
  const cardRefs = useRef([]);
  const lang = locales[window.userLang] ? window.userLang : 'en';
  const dict = locales[lang] || locales.en;
  const getText = key => dict[key] || locales.en[key] || '';
  const reviews = [
    {
      name: k9Funnel ? 'Mark R. & Tommy' : getText('payment_text_328'),
      quote: k9Funnel ? getText('payment_text_356') : getText('payment_text_329'),
      avatar: k9Funnel ? avatar1K9 : avatar1,
      accent: 'var(--ed-brand, #AE66F6)',
    },
    {
      name: k9Funnel ? 'Sarah L. & Moly' : getText('payment_text_330'),
      quote: k9Funnel ? getText('payment_text_357') : getText('payment_text_331'),
      avatar: k9Funnel ? avatar1 : avatar2,
      accent: '#29A073',
    },
    {
      name: k9Funnel ? 'Jason M. & Cherry' : getText('payment_text_332'),
      quote: k9Funnel ? getText('payment_text_358') : getText('payment_text_333'),
      avatar: k9Funnel ? avatar3K9 : avatar3,
      accent: '#F0930C',
    },
    {
      name: k9Funnel ? 'Emily T. & Ami' : getText('payment_text_334'),
      quote: k9Funnel ? getText('payment_text_359') : getText('payment_text_335'),
      avatar: k9Funnel ? avatar4K9 : avatar4,
      accent: 'var(--ed-brand, #AE66F6)',
    },
  ];

  useEffect(() => {
    const viewport = viewportRef.current;
    const cards = cardRefs.current.filter(Boolean);

    if (!viewport || cards.length < 2) {
      return undefined;
    }

    let activeIndex = 0;

    const syncActiveIndex = () => {
      activeIndex = cards.reduce((closestIndex, card, index) => {
        const currentDistance = Math.abs(card.offsetLeft - viewport.scrollLeft);
        const closestDistance = Math.abs(cards[closestIndex].offsetLeft - viewport.scrollLeft);

        return currentDistance < closestDistance ? index : closestIndex;
      }, 0);
    };

    const autoplay = window.setInterval(() => {
      activeIndex = (activeIndex + 1) % cards.length;
      viewport.scrollTo({
        left: cards[activeIndex].offsetLeft,
        behavior: 'smooth',
      });
    }, AUTOPLAY_DELAY);

    viewport.addEventListener('scroll', syncActiveIndex, { passive: true });

    return () => {
      window.clearInterval(autoplay);
      viewport.removeEventListener('scroll', syncActiveIndex);
    };
  }, []);

  return (
    <section className={s.slider}>
      <div className={s.stats}>
        <p className={s.metric}>{getText('payment_text_326')}</p>
        <p className={s.subtitle}>{getText('payment_text_327')}</p>
      </div>

      <div ref={viewportRef} className={s.viewport}>
        <div className={s.track}>
          {reviews.map((review, index) => (
            <article
              key={review.name}
              ref={node => {
                cardRefs.current[index] = node;
              }}
              className={s.card}
              style={{ '--review-accent': review.accent }}
            >
              <div className={s.cardInner}>
                <div className={s.person}>
                  <img
                    className={s.avatar}
                    src={review.avatar}
                    alt={review.name}
                  />
                  <p className={s.name}>{review.name}</p>
                </div>

                <div className={s.content}>
                  <img
                    className={s.stars}
                    src={stars}
                    alt="Five star rating"
                  />
                  <p className={s.quote}>{review.quote}</p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
});
